import { Immutable } from "immer";
import React from "react";
import { RetailStore } from "tsi-common-react/src/models/location";
import { SyncStoreID } from "tsi-common-react/src/models/nominals";
import { fetchJson } from "tsi-common-react/src/utils/ajax";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { jt, t } from "ttag";

import { LocatorSendResultsModal } from "../LocatorSendResults_Modal";
import { TXTSendStorePostData } from "../models";
import { buildStoreData } from "../utils";

type IProps = Immutable<{
    stores: ReadonlyArray<RetailStore>;
    getStoreNumber: (store: Immutable<RetailStore>) => number;
}>;

export const LocatorSendResultsText = (props: IProps): React.ReactNode => {
    const staticURL = useStaticURL();
    const onSubmit = async (
        recipient: string,
        selectedStores: Set<SyncStoreID>,
    ) => {
        const data: TXTSendStorePostData = {
            brand: "TP",
            triggerExternalCall: true,
            program: "text",
            phone: recipient,
            stores: buildStoreData(props.stores, selectedStores),
        };
        await fetchJson("https://api.promosis.com/api/v1/tsi-2249/text", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
    };

    return (
        <LocatorSendResultsModal
            modalClassName="modal-txt"
            buttonLabel={t`Text Results`}
            buttonImgSrc={`${staticURL}img/retail-locator/icon-txt.svg`}
            buttonImgAlt={t`Text Results`}
            modalTitle={t`Text Your Results`}
            modalDescription={(() => {
                const maxNum = <strong key="max">3</strong>;
                const results = <span key="results">{t`results`}</span>;
                const br = <br key="br" />;
                return jt`Check up to ${maxNum} ${results} you would like texted.${br}Message and data rates may apply.`;
            })()}
            inputType="phone"
            inputPlaceholder={t`Enter a Phone Number`}
            submitButtonLabel={t`Send`}
            maxSelected={3}
            stores={props.stores}
            getStoreNumber={props.getStoreNumber}
            onSubmit={onSubmit}
        />
    );
};
